import axios from 'axios'

function getAuthHeader() {
	const token = localStorage.getItem('jwtToken')
	if (!token) return ''
	return token.startsWith('Bearer ') ? token : `Bearer ${token}`
}

function handleUnauthorized() {
	localStorage.removeItem('jwtToken')
	localStorage.removeItem('email')

	if (window.location.pathname !== '/login') {
		window.location.href = '/login'
	}
}

const api = axios.create()

api.interceptors.request.use(config => {
	const auth = getAuthHeader()
	if (auth) {
		config.headers.Authorization = auth
	}
	return config
})

api.interceptors.response.use(
	response => response,
	error => {
		if (error.response?.status === 401) {
			handleUnauthorized()
		}
		return Promise.reject(error)
	},
)

export async function fetchWithAuth(url, options = {}) {
	const auth = getAuthHeader()
	const headers = { ...options.headers }
	if (auth) {
		headers.Authorization = auth
	}

	const response = await fetch(url, { ...options, headers })

	if (response.status === 401) {
		handleUnauthorized()
		throw new Error('Session expired')
	}

	return response
}

export default api
